import React, { useRef } from 'react';
import { Camera, FileText, ImagePlus } from 'lucide-react';
import * as T from '../ui/inlineTheme';

type Props = {
  onFile: (file: File) => void;
  disabled?: boolean;
};

const btn: React.CSSProperties = {
  ...T.btnSecondary,
  flex: 1,
  minWidth: 120,
  opacity: 1,
};

export function ReceiptUpload({ onFile, disabled }: Props) {
  const camRef = useRef<HTMLInputElement>(null);
  const pickRef = useRef<HTMLInputElement>(null);
  const pdfRef = useRef<HTMLInputElement>(null);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const f = e.target.files?.[0];
    if (f) onFile(f);
    e.target.value = '';
  };

  return (
    <div style={{ ...T.flexRowGap, alignItems: 'stretch' }}>
      <input
        ref={camRef}
        type="file"
        accept="image/*"
        capture="environment"
        style={{ display: 'none' }}
        onChange={onChange}
        disabled={disabled}
      />
      <input
        ref={pickRef}
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={onChange}
        disabled={disabled}
      />
      <input
        ref={pdfRef}
        type="file"
        accept="application/pdf,.pdf"
        style={{ display: 'none' }}
        onChange={onChange}
        disabled={disabled}
      />
      <button
        type="button"
        className="sf-btn-secondary"
        disabled={disabled}
        onClick={() => camRef.current?.click()}
        style={{ ...btn, opacity: disabled ? 0.5 : 1 }}
      >
        <Camera size={20} aria-hidden />
        Camera
      </button>
      <button
        type="button"
        className="sf-btn-secondary"
        disabled={disabled}
        onClick={() => pickRef.current?.click()}
        style={{ ...btn, opacity: disabled ? 0.5 : 1 }}
      >
        <ImagePlus size={20} aria-hidden />
        Photo
      </button>
      <button
        type="button"
        className="sf-btn-secondary"
        disabled={disabled}
        onClick={() => pdfRef.current?.click()}
        style={{ ...btn, opacity: disabled ? 0.5 : 1 }}
      >
        <FileText size={20} aria-hidden />
        PDF
      </button>
    </div>
  );
}
